<template>
  <div class="nct-container">
    <a
      v-if="userProfile === 'employee'"
      href="https://kk.kviklogin.dk"
      target="_blank"
      title="Åbn KK filer"
    >
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 150"
        xml:space="preserve"
      >
        <path
          class="st1"
          d="M101.86,26.55v-2.27c0-6.27-5.1-11.36-11.36-11.36H72.77c-6.27,0-11.36,5.1-11.36,11.36v2.27h-4.83v-2.27
c0-6.27-5.1-11.36-11.36-11.36H27.48c-6.27,0-11.36,5.1-11.36,11.36v93.26c0,10.77,8.65,19.53,19.29,19.53l148.61,0.01V26.55H101.86
z M68.03,24.28c0-2.61,2.13-4.74,4.74-4.74H90.5c2.61,0,4.74,2.13,4.74,4.74v2.27H68.03V24.28z M177.39,130.45l-141.98,0
c-6.99,0-12.67-5.79-12.67-12.9V24.28c0-2.61,2.13-4.74,4.74-4.74h17.73c2.61,0,4.74,2.13,4.74,4.74v8.89h127.44V130.45z"
        />
      </svg>
      <img
        src=" data:image/png;base64,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"
        alt="KK filer"
      />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    isMobileApp: {
      type: Boolean,
      default: false,
    },
    userProfile: {
      type: String,
      default: "",
    },
  },

  mounted() {
    if (this.isMobileApp && this.userProfile === "employee") {
      window.open("https://kk.kviklogin.dk", "_blank");
    }
  },
};
</script>

<style scoped>

.nct-container
{
  background-color: white;
}

.nct-container a {
  display: inline-block;
  text-align: left;
  padding: 20px;
  user-select: none;
  text-decoration: none;
  width: 100%;
}

.nct-container a:focus {
  outline: none;
  box-shadow: none;
}

.nct-container svg {
  width: 32px;
  fill: black;
}

.nct-container img {
  width: 100px;
  margin-left: 0.5rem
}
</style>
